<template>
    <div v-loading="loading">
        <layout-headers title='contentsPageTitle' text='contentsPageSubtitle' :redirectButtons="redirectButtons"/>

        <filters :tableData="tableData" v-model="search" @filtered-list="getFilteredList" :fields="[['subtitle', 'en'], ['title', 'en']]" />
        <br>
        <el-card>
            <el-table :data="filteredData" :empty-text="emptyText">
                <el-table-column
                    sortable
                    prop="title.en"
                    :label="$t('contentsTitle')">
                </el-table-column>
                <el-table-column
                     sortable
                    prop="subtitle.en"
                    :label="$t('contentsSubtitle')">
                </el-table-column>
                <el-table-column
                    prop="actions"
                    fixed="right"
                    width="120"
                    :label="$t('tableActions')">
                    <template slot-scope="scope">
                        <el-tooltip 
                        class="item" 
                        effect="dark"
                        placement="left-start">
                        <div slot="content">
                            {{ $t('tooltipInfo') }}
                        </div>
                        <el-button type="info" 
                            icon="el-icon-view"
                            class="table-button"
                            @click="$router.push({name: 'SingleContent', params: {id: scope.row.id}})">
                        </el-button>
                    </el-tooltip>
                        <el-button type="primary" icon="el-icon-edit" class="table-button"
                                @click="edit('ContentEdit', scope.row, 'content')"/>
                        <el-button type="danger" icon="el-icon-delete" class="table-button"
                                @click="showModal(scope.row.id)"/>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <modal :config="modalConfig" @closeModal="deleteContent" />
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import LayoutHeaders from '../LayoutPart/LayoutHeaders'
    import Filters from '../Filters/Filter'
    import {getFilteredList, edit} from '@/helpers/helpers'
    import Modal from '../Modal/Modal'
    import {showModal, closeModal} from "../Modal/ModalHelpers"
    import Content from '@/model/resources'
    import '@/assets/vueWysiwyg.css'

    export default {
        components: {
            Modal,
            LayoutHeaders,
            Filters,
        },
        computed: {
            ...mapGetters({
                contents: 'getContents',
                authToken: 'getAuthToken'
            })
        },
        watch: {
            contents () {
                this.tableData = this.contents
                this.loading = false
            }
        },
        created() {
            this.initList()
        },
        data() {
            return {
                redirectButtons: [
                    {
                        path: 'ContentCreate',
                        param: {
                            isEdit: false,
                            content: {
                                title: {},
                                subtitle: {},
                                text: {}
                            }
                        },
                        text: 'contentsButton'
                    }
                ],
                emptyText: 'Loading...',
                filteredData: undefined,
                id: null,
                loading: true,
                modalConfig: { show: false },
                search: '',
                tableData: [],
                
                
            }
        },
        methods: {
            closeModal,
            edit,
            getFilteredList,
            showModal,
            async initList() {
                await this.$store.dispatch('fetchContents')
                .then(() => {
                    this.emptyText = 'No result'
                })
                this.tableData = this.contents
                this.filteredData = this.contents
                
            },
            deleteContent () {
                this.modalConfig.show = false;
                let { id } = this;
                
                if (id) {
                    this.$store.dispatch('removeContent', id)
                    this.filteredData = this.tableData
                } else {
                    this.showMessage('Id is null')
                }
            },
        }
    }
</script>

<style scoped>
.table-button {
    width: 30px !important; 
    height: 30px !important; 
    padding: 0 !important; 
    margin: 0 !important;
    background: transparent !important;
    color: darkgrey;
    font-size: 20px;
    font-weight: 800;
    border: none;
}

.table-button:hover {
    color: #409EFF !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Contents/Contents.vue